"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../types");
const apiErrorHandler_1 = require("./apiErrorHandler");
class Notifier {
    constructor(callback, pendingTimeout) {
        this.pendingFired = false;
        this.callback = callback;
        this.timeout = setTimeout(() => {
            this.pendingFired = true;
            this.callback(types_1.EVENT_NAMES.REQUEST_STATUS, { status: "pending" });
        }, pendingTimeout);
    }
    requestFinished() {
        clearTimeout(this.timeout);
        if (this.pendingFired) {
            this.callback(types_1.EVENT_NAMES.REQUEST_STATUS, { status: "success" });
        }
    }
    requestFailed(e, callErrorHandler = true) {
        clearTimeout(this.timeout);
        if (callErrorHandler)
            apiErrorHandler_1.apiErrorHandler(e, this.callback);
    }
}
class Notifications {
    constructor(callback, pendingTimeout) {
        this.callback = callback;
        this.pendingTimeout = pendingTimeout !== undefined ? pendingTimeout : 500;
    }
    startRequest() {
        return new Notifier(this.callback, this.pendingTimeout);
    }
    requestFailed(e) {
        apiErrorHandler_1.apiErrorHandler(e, this.callback);
    }
}
exports.Notifications = Notifications;
//# sourceMappingURL=Notifications.js.map